var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.222,32a1.766,1.766,0,0,1-1.257-.521l-9.1-9.1a12.307,12.307,0,0,1-7.417,2.512A12.445,12.445,0,1,1,24.89,12.443a12.307,12.307,0,0,1-2.513,7.42l9.1,9.1A1.778,1.778,0,0,1,30.222,32ZM12.335,3.333a9,9,0,1,0,9,9A9.01,9.01,0,0,0,12.335,3.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.d8ff4056cce5e1e0142a250ebf9a8dd8.svg";
export { ForwardRef as ReactComponent };